import { Controller, useFormContext } from 'react-hook-form';
import CasAutoCompleteAsync, { ICasAutoCompleteAsyncProps } from './CasAutocompleteAsync';

interface CasRHFAutoCompleteAsyncProps
  extends Omit<ICasAutoCompleteAsyncProps, 'onValueChange' | 'onChange'> {
  onChange?:  (event: React.SyntheticEvent, value: any) => void;
  name: string;
  url: string;
}

export default function CasRHFAutoCompleteAsync({
  name,
  defaultValue,
  url,
  onChange,
  ...other
}: CasRHFAutoCompleteAsyncProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <CasAutoCompleteAsync
          {...other}
          url={url}
          defaultValue={field.value}
          error={error}
          onValueChange={(event, value) => {
            field.onChange(value);
            onChange?.(event, value?.id);
          }}
        />
      )}
    />
  );
}
